import request from '../../axios';

const PostEmployeeRequirement = async (
  payload: IEmployeeRequirementPayload,
) => {
  const newPayload = {
    // ad_type: payload.ad_type,
    title: payload.title,
    input_group: payload.input_group?.guid,
    input: payload.input?.guid,
    brs_type: payload.srs_type?.type,
    sub_input: payload.sub_input?.guid,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    wanted_number: payload.wanted_number,
    employing_duration: payload.employing_duration,
    employing_duration_unit: payload.employing_duration_unit?.value,
    only_massage_buyer: payload.only_massage_buyer || false,
    is_change_title: payload?.is_change_title,
  };
  const res = await request.post(`api/v2/wanted/employee-requirement`, {
    ...newPayload,
  });

  return res.data;
};

export default PostEmployeeRequirement;
